import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallOverlayService {
  private _active$ = new BehaviorSubject<boolean>(false);
  private _minimized$ = new BehaviorSubject<boolean>(false);
  private _payload$ = new BehaviorSubject<any>(null);

  start(payload?: any) {
    try {
      this._payload$.next(payload ?? null);
      this._active$.next(true);
      this._minimized$.next(false);
    } catch {}
  }

  end() {
    try {
      this._active$.next(false);
      this._payload$.next(null);
      this._minimized$.next(false);
    } catch {}
  }

  minimize() {
    try {
      this._minimized$.next(true);
    } catch {}
  }

  maximize() {
    try {
      this._minimized$.next(false);
    } catch {}
  }

  setPayload(p: any) {
    try {
      this._payload$.next(p);
    } catch {}
  }

  getActive$(): Observable<boolean> {
    return this._active$.asObservable();
  }

  getMinimized$(): Observable<boolean> {
    return this._minimized$.asObservable();
  }

  getPayload$(): Observable<any> {
    return this._payload$.asObservable();
  }

  getActiveValue(): boolean {
    return this._active$.getValue();
  }

  getMinimizedValue(): boolean {
    return this._minimized$.getValue();
  }
}
